var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbroadCity',{attrs:{"filterName":_vm.filter.title ? _vm.filter.title : '',"selected":_vm.selected,"abroadCitySelected":_vm.abroadCitySelected},on:{"setInputAbroadCity":_vm.setInputAbroadCity}})}
var staticRenderFns = []

export { render, staticRenderFns }